import * as WidgetIcons from "../assets/img/widgets/widgetIcons.js";

const basicWidgetValues = {
  minW: undefined,
  minH: undefined,
  maxW: undefined,
  maxH: undefined,
  borderColor: "#7a0625ff",
  bgColor: "#fff",
  fontColor: "#662336",
  actionBarBG: "#91657185",
  showTitleBar: true,
  borderRadiusTopLeft: 6,
  borderRadiusTopRight: 6,
  borderRadiusBottomLeft: 6,
  borderRadiusBottomRight: 6,
  borderWidth: 0,
  contentBG: "#fff",
  dividerColor: "#dee2e6",
  titleColor: "#212529",
};

export const WIDGET_TYPES = Object.freeze({
  //typos shall not be fixed!
  //will break existing saved dashboards.
  BANNER_WIDGET: "banner-widget",
  CONTACTS: "contacts-Widget",
  IMAGE_GALLERY: "imageGallery",
  HIGHLIGHTED_PRODUCTS: "highlighted-products",
  LINK: "link",
  NEWS_BIG: "news",
  NEWS_COLUMN: "news-post",
  PROJECT_KEY_RESOURCES: "project-key-resources",
  PROJECT_PROGRESS: "project-progress",
  RECENTLY_MODIFIED_FILES: "recently-modefied-files", //keep the misspelled name
  SEARCH_WIDGET: "search-widget",
  STATIC_WILMA_BANNER: "static-wilma-banner",  // Removed: STATIC_WILMA_BANNER - Keep type definition.
  FOCUSTILE_WIDGET: "focustile-widget",
  TEXTEDITOR: "informationmessage",
  WORKSPACE: "workspace",
  WORKSPACES: "workspaces",
  YOUTUBE: "video",
});

export const widgetList = [
  {
    ...basicWidgetValues,
    i: "a",
    x: 0,
    y: 0,
    w: 2,
    h: 4,
    image: WidgetIcons.YouTube,
    title: "widget.youtube",
    desc: "widget.youtubeDesc",
    type: WIDGET_TYPES.YOUTUBE,
    videoId: null,
    isConfigured: false,
  },
  {
    ...basicWidgetValues,
    i: "b",
    x: 0,
    y: 0,
    w: 2,
    h: 20,
    image: WidgetIcons.RecentlyModifiedFiles,
    title: "widget.recentlyModified",
    desc: "widget.recentlyModifiedDesc",
    type: WIDGET_TYPES.RECENTLY_MODIFIED_FILES,
    isConfigured: true,
  },
  {
    ...basicWidgetValues,
    i: "c",
    x: 0,
    y: 0,
    w: 8,
    h: 17,
    image: WidgetIcons.NewsWidgetWide,
    title: "widget.news",
    desc: "widget.newsDesc",
    type: WIDGET_TYPES.NEWS_BIG,
    newsTemplate: 1,
    isConfigured: true,
  },
  {
    ...basicWidgetValues,
    i: "c",
    x: 0,
    y: 0,
    w: 8,
    h: 17,
    image: WidgetIcons.NewsWidgetWide,
    title: "widget.newsFlow",
    desc: "widget.newsFlowDesc",
    type: WIDGET_TYPES.NEWS_FLOW,
    newsTemplate: 1,
    isConfigured: true,
  },
  {
    ...basicWidgetValues,
    i: "d",
    x: 0,
    y: 0,
    w: 2,
    h: 7,
    minW: 2,
    minH: 7,
    image: WidgetIcons.Workspace,
    title: "widget.siteWidget",
    desc: "widget.siteWidgetDesc",
    type: WIDGET_TYPES.WORKSPACE,
    isConfigured: false,
  },
  //{
  //  ...basicWidgetValues,
  //  i: "e",
  //  x: 0,
  //  y: 0,
  //  w: 2,
  //  h: 7,
  //  minW: 2,
  //  minH: 7,
  //  image: WidgetIcons.SiteLayers,
  //  title: "widget.pageLinkTitle",
  //  desc: "widget.pageLinkTitleDesc",
  //  type: "page-link",
  //  isConfigured: false,
  //},
  {
    ...basicWidgetValues,
    i: "f",
    x: 0,
    y: 0,
    w: 8,
    h: 4,
    image: WidgetIcons.TextEditor,
    title: "widget.information",
    desc: "widget.informationDesc",
    type: WIDGET_TYPES.TEXTEDITOR,
    isConfigured: false,
  },
  {
    ...basicWidgetValues,
    i: "g",
    x: 0,
    y: 0,
    w: 2,
    h: 4,
    image: WidgetIcons.Link,
    title: "widget.linkWidget",
    desc: "widget.linkWidgetDesc",
    type: WIDGET_TYPES.LINK,
    isConfigured: false,
  },
  {
    ...basicWidgetValues,
    i: "h",
    x: 0,
    y: 0,
    w: 2,
    h: 20,
    image: WidgetIcons.NewsWidgetNarrow,
    title: "widget.newsPost",
    desc: "widget.newsPostDesc",
    type: WIDGET_TYPES.NEWS_COLUMN,
    isConfigured: true,
  },
  {
    ...basicWidgetValues,
    i: "i",
    x: 0,
    y: 0,
    w: 2,
    h: 20,
    image: WidgetIcons.Workspaces,
    title: "widget.myWorkspaces",
    desc: "widget.myWorkspaces",
    type: WIDGET_TYPES.WORKSPACES,
    isConfigured: true,
  },
  {
    ...basicWidgetValues,
    i: "j",
    x: 0,
    y: 0,
    w: 8,
    h: 16,
    image: WidgetIcons.Workspaces,
    title: "widget.imageGallery",
    desc: "widget.imageGallery",
    type: WIDGET_TYPES.IMAGE_GALLERY,
    isConfigured: true,
  },
  {
    ...basicWidgetValues,
    i: "j_2",
    x: 0,
    y: 0,
    w: 8,
    h: 16,
    image: WidgetIcons.Workspaces,
    title: "widget.highlightedProducts",
    desc: "widget.highlightedProductsy",
    type: WIDGET_TYPES.HIGHLIGHTED_PRODUCTS,
    isConfigured: true,
  },
  {
    ...basicWidgetValues,
    i: "k",
    x: 0,
    y: 0,
    w: 2,
    h: 20,
    image: WidgetIcons.ContactsWidget,
    title: "widget.contactsWidget.title",
    desc: "widget.contactsWidget.description",
    type: WIDGET_TYPES.CONTACTS,
    isConfigured: true,
  },
  {
    ...basicWidgetValues,
    i: "l",
    x: 0,
    y: 0,
    w: 8,
    h: 9,
    image: WidgetIcons.ContactsWidget,
    name: "widget.projectKeyResourcesWidget.title",
    title: "widget.projectKeyResourcesWidget.title",
    desc: "widget.projectKeyResourcesWidget.description",
    type: WIDGET_TYPES.PROJECT_KEY_RESOURCES,
    isConfigured: true,
  },
  {
    ...basicWidgetValues,
    i: "m",
    x: 0,
    y: 0,
    w: 8,
    h: 5,
    image: WidgetIcons.ContactsWidget,
    name: "widget.projectProgressWidget.title",
    title: "widget.projectProgressWidget.title",
    desc: "widget.projectProgressWidget.description",
    type: WIDGET_TYPES.PROJECT_PROGRESS,
    isConfigured: true,
  },
  //{
  //  ...basicWidgetValues,
  //  i: "n",
  //  x: 0,
  //  y: 0,
  //  w: 8,
  //  h: 3,
  //  image: WidgetIcons.TextEditor,
  //  name: "widget.staticWilmaBannerWidget.title",
  //  title: "widget.staticWilmaBannerWidget.title",
  //  desc: "widget.staticWilmaBannerWidget.description",
  //  type: WIDGET_TYPES.STATIC_WILMA_BANNER,  // Removed: STATIC_WILMA_BANNER
  //  isConfigured: true,
  //},
  {
    ...basicWidgetValues,
    i: "o",
    x: 0,
    y: 0,
    w: 8,
    h: 3,
    image: WidgetIcons.Search,
    name: "search",
    title: "widget.search",
    desc: "widget.search",
    type: WIDGET_TYPES.SEARCH_WIDGET,
    isConfigured: true,
  },
  {
    ...basicWidgetValues,
    i: "p",
    x: 0,
    y: 0,
    w: 8,
    h: 3,
    image: WidgetIcons.TextEditor,
    name: "widget.bannerWidget.title",
    title: "widget.bannerWidget.title",
    desc: "widget.bannerWidget.description",
    type: WIDGET_TYPES.BANNER_WIDGET,
    isConfigured: true,
  },
  {
    ...basicWidgetValues,
    i: "z",
    x: 0,
    y: 0,
    w: 2,
    h: 4,
    image: WidgetIcons.TextEditor, // byt gärna till bättre ikon
    title: "widget.focusTileWidget",
    desc: "widget.focusTileWidgetDesc",
    type: WIDGET_TYPES.FOCUSTILE_WIDGET,
    settings: {
      iconName: "PeopleAltOutlined",
      iconColor: "#CE122D",
      iconSize: 38,
      headingText: "1999",
      headingFontSize: 38,
      headingColor: "#000000",
      subheadingText: "Inloggade användare",
      subheadingFontSize: 14,
      subheadingColor: "#666666",
      backgroundColor: "#ffffff",
    },
    isConfigured: true,
  },
];
